import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AccessPipe } from './access.pipe';
import { BytesPipe } from './bytes.pipe';
import { CapitalizePipe } from './capitalize.pipe';
import { ColorConverterPipe } from './color-converter.pipe';
import { FeaturePipe } from './feature.pipe';
import { FilterObjectByFieldPipe } from './filter.pipe';
import { GamePipe } from './game.pipe';
import { IsArrayPipe } from './is-array.pipe';
import { ParseLogActionPipe } from './parse-log-action.pipe';
import { ParseThreatPipe } from './parse-threat.pipe';
import { PaymentLogoPipe } from './payment-logo.pipe';
import { PermissionPipe } from './permission.pipe';
import { PricingIntervalPipe } from './pricing-interval.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SortPipe } from './sort.pipe';
import { SplitPipe } from './split.pipe';
import { StatePipe } from './state.pipe';
import { TierPipe } from './tier.pipe';
import { TimeDistancePipe } from './time-distance.pipe';
import { TrimPipe } from './trim.pipe';
import { UseragentPipe } from './useragent.pipe';
import { SubstringPipe } from './substring.pipe';
import { ReplacePipe } from './replace.pipe';
import { PaymentNamePipe } from './payment-name.pipe';
@NgModule({
  declarations: [
    StatePipe,
    ColorConverterPipe,
    GamePipe,
    PermissionPipe,
    AccessPipe,
    CapitalizePipe,
    FilterObjectByFieldPipe,
    UseragentPipe,
    TimeDistancePipe,
    SplitPipe,
    TrimPipe,
    IsArrayPipe,
    ParseThreatPipe,
    SafeHtmlPipe,
    ParseLogActionPipe,
    BytesPipe,
    SortPipe,
    TierPipe,
    FeaturePipe,
    PaymentLogoPipe,
    PricingIntervalPipe,
    SubstringPipe,
    TierPipe,
    ReplacePipe,
    PaymentNamePipe,
  ],
  imports: [CommonModule],
  exports: [
    StatePipe,
    ColorConverterPipe,
    GamePipe,
    PermissionPipe,
    AccessPipe,
    CapitalizePipe,
    FilterObjectByFieldPipe,
    UseragentPipe,
    TimeDistancePipe,
    SplitPipe,
    IsArrayPipe,
    ParseThreatPipe,
    SafeHtmlPipe,
    ParseLogActionPipe,
    BytesPipe,
    SortPipe,
    TierPipe,
    FeaturePipe,
    PaymentLogoPipe,
    PricingIntervalPipe,
    SubstringPipe,
    TierPipe,
    ReplacePipe,
    PaymentNamePipe,
  ],
})
export class CustomPipesModule {}
